const useAppVersion = () => {
  const appVersion = import.meta.env.VITE_APP_VERSION || '0.0.1';
  return { appVersion };
};

export default useAppVersion;
